import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Injectable, OnDestroy } from "@angular/core";
import { FormControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { GenericComponent } from "./generic-component";

declare var $: any;

@Injectable()

export class GenericSearchComponent extends GenericComponent implements OnDestroy {

  constructor() {
    super();
    registerLocaleData(es);
  }

  ngOnDestroy() {
    if (this.subscriptionformGroupSearch) { this.subscriptionformGroupSearch.unsubscribe(); }
    if (this.subscriptionaPagination) { this.subscriptionaPagination.unsubscribe(); }
  }

  _formGroupSearch: UntypedFormGroup;
  isLoadingSearch: boolean = true;
  isLoadingPage: boolean = true;
  isRequestSuccess: boolean = true;
  recordsCount: number = 0;
  recordsPerPage: number = 0;
  data: Array<any> = [];
  arrayPage: Array<any> = [];
  prevRequestSearch: any = {};
  countFilterTag: number = 0;

  subscriptionformGroupSearch: Subscription;
  subscriptionaPagination: Subscription;

  onRemoveOption(option: string, index: number) {
    (this._formGroupSearch.get(option) as UntypedFormArray).controls[index].setValue(false);
  }

  onOptionReset(option: string) {
    this._formGroupSearch.get(option).setValue('');
  }


  onCheckboxReset(option: string) {
    this._formGroupSearch.get(option).setValue(false);
  }

  onOptionResetZero(option: string) {
    this._formGroupSearch.get(option).setValue(0);
  }


  onUncheckRadio(option: string, value: number) {
    if (+this._formGroupSearch.get(option).value === value) {
      this._formGroupSearch.get(option).setValue(0);
    }
  }

  changePage(page: any) {
    this.optionPage.setValue(page);
  }

  setDataError(err: any, toResults: boolean | undefined = false) {
    this.data = [];
    this.arrayPage = [];
    this.isRequestSuccess = false;
    this.isLoadingSearch = false;
    console.log(err);
    this.toResults(toResults)
  }

  private toResults(toResults: boolean | undefined) {


    if (toResults === true || (toResults === false && window.innerWidth > 768)) {
      setTimeout(() => {
        try {
          $('html,body').animate({ scrollTop: $("a[name='linkResults']").offset().top - 22 }, 0);
        } catch {
          // dont throw an error if the element linkresults doesnt exists
        }

      }, 0);
    }
  }

  setDataResponse(res: any, toResults: boolean | undefined = false) {
    this.data = res['results'] !== null ? res['results'] || [ ] : [];
    this.recordsCount = res['recordsCount'];
    this.recordsPerPage = res['recordsPerPage'];
    this.arrayPage = this.getArrayPagination(this.optionPage.value, res['recordsCount'], res['recordsPerPage']);
    this.isLoadingSearch = false;
    this.isRequestSuccess = true;
    this.toResults(toResults);
  }

  getArrayPagination(actualpage: number, recordsCount: number, recordsPerPage: number): any[] {

    var arr = [];

    var lastpage = Math.ceil(recordsCount / recordsPerPage);
    var insertItem = 0;

    if (actualpage > 1) {
      arr.push({ page: 1, label: '«', title: 'Primero', active: false });
      arr.push({ page: actualpage - 1, label: '⟨', title: 'Anterior', active: false });
    }



    var customPage = actualpage - 2;
    if (customPage < 1) { customPage = 1 };

    var maxPage = customPage + 4;
    if (lastpage < maxPage) maxPage = lastpage;

    while (maxPage - customPage < 4) {
      if (customPage - 1 > 0) {
        customPage--;
      }
      else {
        break;
      }
    }


    for (let index = customPage; index <= maxPage; index++) {

      if (index === actualpage) {
        arr.push({ page: index, label: index, active: true });
      }
      else {
        arr.push({ page: index, label: index, active: false });
      }
      insertItem++;
    }

    if (actualpage < lastpage) {
      arr.push({ page: actualpage + 1, label: '⟩', title: 'Siguiente', active: false });
      arr.push({ page: lastpage, label: '»', title: 'Último', active: false });
    }


    if (insertItem > 0) {
      return arr;
    }
    {
      return [];
    }
  }

  resetPage(): void {
    this.optionPage.setValue(1, { emitEvent: false });
  }

  get optionFilter() { return this._formGroupSearch.get('optionFilter') as FormControl; }
  get optionOrder() { return this._formGroupSearch.get('optionOrder') as FormControl; }
  get optionPage() { return this._formGroupSearch.get('optionPage') as FormControl; }

}
